//dependencies
import React from "react";

// components
import Chip, { Color } from "../..";
// styles
import css from "./TableChip.module.scss";

interface TableChipProps {
	label: string | React.ReactNode;
	color: Color;
}
/**
 * @deprecated
 */
const TableChip = (props: TableChipProps) => {
	const { label, color } = props;

	return <Chip label={label} color={color} className={css.tableChip} />;
};

/** @deprecated */
export default TableChip;
